import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map, of } from 'rxjs';
import { profileStatisticsActions } from '../actions/profile-statistics.actions';
import { ProfileStatisticsHttpService } from '../services/http.service';

@Injectable()
export class ProfileStatisticsEffects {
    private readonly actions = inject(Actions);
    private readonly httpService = inject(ProfileStatisticsHttpService);

    getProfileStatistics$ = createEffect(() => {
        return this.actions.pipe(
            ofType(profileStatisticsActions.getProfileStatistics),
            exhaustMap(() => {
                return this.httpService.getProfileStatistics().pipe(
                    map((payload) => profileStatisticsActions.getProfileStatisticsSuccess({ payload })),
                    catchError((error) => of(profileStatisticsActions.getProfileStatisticsError({ code: error.status }))),
                );
            }),
        );
    });
}
